import React, { useState, useEffect } from 'react';
import { AlarmasLayout } from '../../components/alarmas/AlarmasLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Skeleton } from '../../components/ui/skeleton';
import { toast } from 'sonner';
import { Clock, Power, PowerOff } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AlarmasHistorialPage() {
    const [eventos, setEventos] = useState([]);
    const [loading, setLoading] = useState(true);

    const token = localStorage.getItem('token');
    const headers = { 'Authorization': `Bearer ${token}` };

    useEffect(() => {
        (async () => {
            try {
                const res = await fetch(`${API_URL}/api/alarmas/historial?limit=100`, { headers });
                if (res.ok) setEventos(await res.json());
            } catch { toast.error('Error'); }
            finally { setLoading(false); }
        })();
    }, []);

    return (
        <AlarmasLayout>
            <div className="space-y-6 animate-fade-in">
                <h1 className="font-black text-3xl uppercase tracking-tight flex items-center gap-3" data-testid="alarmas-historial-title">
                    <Clock className="h-7 w-7 text-red-500" />
                    Historial de Eventos
                </h1>

                {loading ? (
                    <div className="space-y-3">{[...Array(5)].map((_, i) => <Skeleton key={i} className="h-16" />)}</div>
                ) : eventos.length === 0 ? (
                    <Card className="border-2">
                        <CardContent className="py-12 text-center text-muted-foreground">
                            Sin eventos registrados
                        </CardContent>
                    </Card>
                ) : (
                    <div className="space-y-2">
                        {eventos.map(ev => (
                            <Card key={ev.id} className="border">
                                <CardContent className="p-4 flex items-center gap-4">
                                    <div className={`p-2 rounded-full ${ev.action === 'on' ? 'bg-red-500/10' : 'bg-muted'}`}>
                                        {ev.action === 'on' ? <Power className="h-5 w-5 text-red-500" /> : <PowerOff className="h-5 w-5 text-muted-foreground" />}
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <p className="font-medium">
                                            <span className="text-muted-foreground">{ev.usuario_nombre}</span> {ev.action === 'on' ? 'encendio' : 'apago'} <span className="font-bold">{ev.dispositivo_nombre}</span>
                                        </p>
                                        <p className="text-xs text-muted-foreground">
                                            {new Date(ev.created_at).toLocaleString()}
                                        </p>
                                    </div>
                                    <Badge variant={ev.action === 'on' ? 'destructive' : 'secondary'}>
                                        {ev.action === 'on' ? 'ON' : 'OFF'}
                                    </Badge>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                )}
            </div>
        </AlarmasLayout>
    );
}
